// src/components/ui/ConsentBanner.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  denyGoogleAnalytics,
  getAnalyticsConsentStatus,
  isAnalyticsConfigured,
  loadGoogleAnalytics,
  OPEN_CONSENT_BANNER_EVENT,
  setAnalyticsConsentStatus,
} from '../../lib/analyticsConsent';
import './ConsentBanner.css';

function ConsentBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isAnalyticsConfigured()) {
      return;
    }

    const storedConsent = getAnalyticsConsentStatus();

    if (storedConsent === 'granted') {
      loadGoogleAnalytics();
    } else if (storedConsent === 'denied') {
      denyGoogleAnalytics();
    } else {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    const handleOpenConsentBanner = () => {
      if (isAnalyticsConfigured()) {
        setIsVisible(true);
      }
    };

    window.addEventListener(OPEN_CONSENT_BANNER_EVENT, handleOpenConsentBanner);
    return () => {
      window.removeEventListener(
        OPEN_CONSENT_BANNER_EVENT,
        handleOpenConsentBanner
      );
    };
  }, []);

  const handleAccept = () => {
    setAnalyticsConsentStatus('granted');
    loadGoogleAnalytics();
    setIsVisible(false);
  };

  const handleReject = () => {
    setAnalyticsConsentStatus('denied');
    denyGoogleAnalytics();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="consent-banner">
      <p>{t('consentBanner.message')}</p>
      <div className="consent-banner__actions">
        <button type="button" onClick={handleAccept}>
          {t('consentBanner.accept')}
        </button>
        <button type="button" onClick={handleReject}>
          {t('consentBanner.reject')}
        </button>
        <Link to="/privacy-policy" className="footer__link">
          {t('consentBanner.policyLink')}
        </Link>
      </div>
    </div>
  );
}

export default ConsentBanner;
